var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpracheDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Sprache-DE__Icn/40px/Sprache-DE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Sprache-DE__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Sprache-DE__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.4233672,25 C14.1487005,25 14.8882005,24.8781667 15.6418672,24.6345 C16.3955339,24.3908333 17.0812005,24.0225 17.6988672,23.5295 C18.3165339,23.0365 18.8208672,22.4131667 19.2118672,21.6595 C19.6028672,20.9058333 19.7983672,20.0133333 19.7983672,18.982 C19.7983672,17.962 19.6283672,17.0751667 19.2883672,16.3215 C18.9483672,15.5678333 18.4950339,14.9416667 17.9283672,14.443 C17.3617005,13.9443333 16.7100339,13.5731667 15.9733672,13.3295 C15.2367005,13.0858333 14.4717005,12.964 13.6783672,12.964 L13.6783672,12.964 L8.93536719,12.964 L8.93536719,25 L13.4233672,25 Z M12.6753672,23.062 L11.0773672,23.062 L11.0773672,14.902 L13.0323672,14.902 C13.6897005,14.902 14.2932005,14.9785 14.8428672,15.1315 C15.3925339,15.2845 15.8685339,15.5225 16.2708672,15.8455 C16.6732005,16.1685 16.9877005,16.5906667 17.2143672,17.112 C17.4410339,17.6333333 17.5543672,18.2566667 17.5543672,18.982 C17.5543672,19.7186667 17.4268672,20.3448333 17.1718672,20.8605 C16.9168672,21.3761667 16.5683672,21.7955 16.1263672,22.1185 C15.6843672,22.4415 15.1658672,22.6795 14.5708672,22.8325 C13.9758672,22.9855 13.3440339,23.062 12.6753672,23.062 L12.6753672,23.062 Z M30.2648281,25 L30.2648281,23.062 L24.1278281,23.062 L24.1278281,19.798 L29.6528281,19.798 L29.6528281,17.86 L24.1278281,17.86 L24.1278281,14.902 L29.9588281,14.902 L29.9588281,12.964 L21.9858281,12.964 L21.9858281,25 L30.2648281,25 Z",
    id: ".._.._src_svg_Icn_40px_Sprache-DE__DE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpracheDe);
export default __webpack_public_path__ + "static/media/Sprache-DE.516d4ef6ec27c792458d8d133a12b73a.svg";
export { ForwardRef as ReactComponent };